// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3e_i9","signatureBlock":"Footer_signatureBlock__3muL8","signature":"Footer_signature__IBEMf"};